<template>
    <div>
        <head-layout title="Account Forms" />

        <div class="text-h2">Account Forms</div>

        <v-data-table
            :headers="[
                { text: 'Organisation Name', value: 'company_name' },
                { text: 'Created At', value: 'created_at_string' },
                { text: '', value: 'label' },
                { text: '', value: 'options' },
            ]"
            :items="$page.props.accountForms"
            sort-by="created_at_string"
            sort-desc
        >
            <template v-slot:item.label="{ item }">
                <v-chip v-if="!item.viewed" color="primary">New</v-chip>
                <v-chip
                    v-if="item.credit_required && !item.credit_approved_at"
                    color="secondary"
                >
                    Credit Approval Required
                </v-chip>
            </template>
            <template v-slot:item.options="{ item }">
                <inertia-link
                    :href="route('manage.account-forms.show', item.uuid)"
                >
                    <v-btn link>View</v-btn>
                </inertia-link>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import HeadLayout from "../../Layouts/HeadLayout";

export default {
    name: "AccountForms",
    components: { HeadLayout },
};
</script>

<style scoped></style>
